export default "/_next/static/images/086c8e3722bcd06fd3c9db164a4fd845.jpg";